import React from "react";
import PropTypes from "prop-types";
import Modal from "./Modal";
import Button from "../Button/Button";
import Loader from "../Loader/Loader";

const ConfirmModal = ({
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  confirmColor,
  title,
  loading,
  confirmLoading
}) => (
  <Modal onClose={onCancel} className="confirm">
    <div className="modal__header">
      <div className="modal__title">{title}</div>
      <div className="modal__controls">
        <Button onClick={onCancel} color="gray">
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          disabled={loading || confirmLoading}
        >
          {confirmText}
        </Button>
      </div>
    </div>
    {confirmLoading && <Loader />}
    {!confirmLoading && (
      <div className="modal__body">
        Вы уверены, что хотите совершить действие?
      </div>
    )}
  </Modal>
);

ConfirmModal.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmColor: PropTypes.string,
  title: PropTypes.string,
  loading: PropTypes.bool
};

ConfirmModal.defaultProps = {
  confirmText: "Да",
  cancelText: "Нет"
};

export default ConfirmModal;
